import { Component } from '@angular/core';
import { AlertController, NavController, NavParams } from 'ionic-angular';
import { ProductCreateWfoodcostImagePage } from "../product-create-wfoodcost-image/product-create-wfoodcost-image";
import { ProvidersServices } from "../../../../providers/services";
import { ProductsServices } from "../../../services";
import { Globals } from "../../../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { StockListPage } from '../../../../stock/stock-list/stock-list';

/**
 * Generated class for the ProductCreateWfoodcostProviderPricePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-create-wfoodcost-provider-price',
  templateUrl: 'product-create-wfoodcost-provider-price.html',
})
export class ProductCreateWfoodcostProviderPricePage {
  term: string;
  product_measurement: any;
  product_uid: string;
  update_state: boolean = false;
  price_static: any;
  provider_static: any;
  product_name: any;
  product: any;

  show_alert: boolean = true;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public providersServices: ProvidersServices,
    public productsServices: ProductsServices,
    public globals: Globals,
    private alertCtrl: AlertController,
    public translate: TranslateService,) {

    //this.ingredientsServices.getList(this.globals.restaurant_uid);
    this.product_measurement = this.navParams.get('product_measurement');
    this.product_uid = this.navParams.get('product_uid');
    this.update_state = this.navParams.get('update_state');
    this.product_name = this.navParams.get('product_name');
    this.product = this.navParams.get('product');

  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.show_alert && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.globals.side_menu_active = 'stock';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.productsServices.afs.collection('products').doc(this.product_uid).delete();
                resolve();
                this.navCtrl.setRoot(StockListPage);
              },
            },
          ],
        });
        alert.present();
      } else {
        resolve();
      }
    });
  }

  calculateRow(index) {
    var price_notax = this.providersServices.providers_array_tmp[index][11];
    var tax = this.providersServices.providers_array_tmp[index][12];
    //var price = this.providersServices.providers_array_tmp[index][13];
    var $total = price_notax + (price_notax * tax / 100);

    this.providersServices.providers_array_tmp[index][13] = $total;
    //posar el mateix impost a tots els inputs de impost
    this.tax4All(index);

  }

  tax4All(index) {
    for (let provider of this.providersServices.providers_array_tmp) {
      provider[12] = this.providersServices.providers_array_tmp[index][12];

      var price_notax = provider[11];
      var tax = provider[12];
      var $total = price_notax + (price_notax * tax / 100);

      provider[13] = $total;
    }
  }


  delete(index) {
    this.providersServices.providers_array_tmp.splice(index, 1);
  }

  update() {
    this.show_alert = false;
    var _array = Array();
    for (var i = 0; this.providersServices.providers_array_tmp.length > i; i++) {
      //agafar el predeterminat
      if (this.providersServices.providers_array_tmp[i][10]) {
        this.price_static = this.providersServices.providers_array_tmp[i][11];
        this.provider_static = this.providersServices.providers_array_tmp[i][1];
      }

      _array.push({
        uid: this.providersServices.providers_array_tmp[i][0],
        default: this.providersServices.providers_array_tmp[i][10],
        price_static: this.providersServices.providers_array_tmp[i][11],
        name_static: this.providersServices.providers_array_tmp[i][1],
        pricetotal_static: this.providersServices.providers_array_tmp[i][13],
        tax_static: this.providersServices.providers_array_tmp[i][12],
        updated_at: new Date(),
      });
    }

    if (_array.length > 0) { //Controlamos que en array tenga como minimo algun elemento.
      this.productsServices.afs.collection('products').doc(this.product_uid).update({
        'providers': _array,
        'price_static': this.price_static,
        'provider_static': this.provider_static,
        'updated_at': new Date(),
        'updated_user': this.globals.user_name
      }).then(() => {
        //dataset product_price/product_provider
        this.globals.dataSet('product_cost', this.price_static, '', this.product_name);
        //redirect
        if (this.update_state) {
          this.globals.GAtrackView('Products', 'Products - Price providers - Update', this.globals.restaurant.email, 'Create/Update', 'Update price providers', 'Products', this.product_name);
          //
          this.navCtrl.remove(this.navCtrl.getPrevious().index);
          this.navCtrl.pop();
        } else {
          this.globals.GAtrackView('Products', 'Products - Price providers - Create', this.globals.restaurant.email, 'Create/Update', 'Create price providers', 'Products', this.product_name);
          //
          this.navCtrl.push(ProductCreateWfoodcostImagePage, {
            product_uid: this.product_uid,
            product_name: this.product_name,
          })
        }
      });
    } else {
      this.navCtrl.push(ProductCreateWfoodcostImagePage, {
        product_uid: this.product_uid,
        product_name: this.product_name,
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-provider-price/product-create-wfoodcost-provider-price.ts